
export default function FutureSection() {
  const futureFeatures = [
    {
      icon: 'ri-road-map-line',
      title: 'Outdoors Digitais Otimizados',
      description: 'IA aplicada em mídia exterior para máximo impacto urbano'
    },
    {
      icon: 'ri-store-2-line',
      title: 'Vitrines LED de Alto Impacto',
      description: 'Transformação de fachadas em experiências interativas'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Soluções Personalizadas',
      description: 'Adaptação da tecnologia para qualquer ambiente'
    }
  ];

  return (
    <section className="py-20 bg-gray-900 relative overflow-hidden">
      <div 
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=futuristic%20smart%20city%20with%20LED%20displays%20and%20digital%20billboards%2C%20advanced%20urban%20technology%20landscape%2C%20AI-powered%20advertising%20screens%2C%20modern%20cityscape%20with%20blue%20and%20purple%20neon%20lights%2C%20high-tech%20digital%20infrastructure&width=1920&height=1080&seq=future-city&orientation=landscape')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      ></div>
      
      <div className="absolute inset-0 bg-gradient-to-br from-gray-900/90 to-black/80"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Futuro & <span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">Expansão</span>
          </h2>
          <div className="max-w-4xl mx-auto">
            <p className="text-xl text-gray-300 leading-relaxed mb-8">
              Estamos construindo o futuro da comunicação inteligente, expandindo para outdoors 
              digitais otimizados por IA, vitrines de LED de alto impacto e soluções personalizadas 
              para qualquer ambiente.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {futureFeatures.map((feature, index) => (
            <div 
              key={index}
              className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-8 border border-gray-700 text-center hover:border-blue-500/50 transition-all duration-300"
            >
              <div className="w-20 h-20 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${feature.icon} text-white text-3xl`}></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">{feature.title}</h3>
              <p className="text-gray-300 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}